import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'purchaseOrderDisplayFormat',
})
export class PurchaseOrderDisplayFormatPipe implements PipeTransform {
  transform(purchaseOrder :any) :string {
    if (purchaseOrder.supplier_order_type === 'INTERNAL_TRANSFER_ORDER') {
      return `[Transfer Order] Order # ${purchaseOrder.internal_resource?.order_number}`;
    }

    return purchaseOrder.factory?.factory_name;
  }
}
